import React, { useState, useEffect } from 'react';
import { Modal } from 'react-responsive-modal';
import { Field, FieldArray, SubmissionError, reduxForm } from 'redux-form';
import { renderDollar, renderField, renderSwitch } from '../../../../../Utils/renderField/renderField';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { api } from 'api';
import { months } from '../../../../../Utils/months';
import RecetaRow from './RecetaRow';
import { validate } from './validate';
import { PRODUCT } from '../../../../../../../utility/constants';

const TableRow = ({ system, index, fields }) => {
    const _months = months;
    const isNew = fields.get(index).isNew;

    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`}>
                {_months.map(month => (
                    <td key={month}>
                        <Field
                            name={`${system}.${month}`}
                            type="text"
                            component={renderDollar}
                            className="form-control text-right money-input"
                            placeholder='$ 0.00'
                        />
                    </td>
                ))}
            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({
    fields,
    change,
    initialValues,
}) => {
    const _months = months || [];
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            setLoading(true);
            // Verificar si fields existe y es un array
            if (!fields || typeof fields.push !== 'function') {
                console.error("Fields no es un objeto válido:", fields);
                setError("Error al cargar la tabla. Por favor, intente nuevamente.");
                return;
            }

            // Inicializar fields si está vacío
            if (fields.length === 0) {
                fields.push({ isNew: true });
            }
            
            setLoading(false);
        } catch (err) {
            console.error("Error al inicializar la tabla:", err);
            setError("Error al inicializar la tabla. Por favor, intente nuevamente.");
            setLoading(false);
        }
    }, [fields]);

    // Si hay un error, mostrar mensaje
    if (error) {
        return (
            <div className="alert alert-danger">
                {error}
                <button 
                    className="btn btn-outline-danger ml-3" 
                    onClick={() => {
                        setError(null);
                        if (fields.length === 0) {
                            fields.push({ isNew: true });
                        }
                    }}
                >
                    Reintentar
                </button>
            </div>
        );
    }

    // Si está cargando, mostrar indicador
    if (loading) {
        return (
            <div className="text-center p-3">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
                <p className="mt-2">Cargando tabla...</p>
            </div>
        );
    }

    // Verificar si fields tiene elementos
    if (!fields || fields.length === 0) {
        return (
            <div className="alert alert-warning">
                No hay datos disponibles.
                <button 
                    className="btn btn-outline-warning ml-3" 
                    onClick={() => {
                        fields.push({ isNew: true });
                    }}
                >
                    Agregar fila
                </button>
            </div>
        );
    }

    return (
        <div className="tabla-wrapper table-padding pr-4 pl-4">
            <div className="table-responsive">
                <table className="table custom-table table-striped mb-0">
                    <thead>
                        <tr>
                            {_months.map((_, index) => (
                                <th key={index}>
                                    {index + 1}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((system, index) => (
                            <TableRow
                                key={index}
                                system={system}
                                index={index}
                                fields={fields}
                                change={change}
                                initialValues={initialValues}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const TableCategory = ({ fields, change, packingId, dollarExchange, isPacking, recipe='' }) => {
    const [currency, setCurrency] = useState("USD");

    const fetchData = (endpoint, params) => {
        return api.get(endpoint, { product_sales__product: PRODUCT["LATEX"], ...params })
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getCustomers = (search) => {
        return fetchData('sub-product-sales', {
            search
        });
    };

    const handleAddField = () => {
        const initialValues = {
            is_dollar: currency === "USD",
            packingId: packingId,
            name: "",
            sub_product: [],
            is_unit_measurement: true,
        };
        fields.push(initialValues);
    };

    return (
        <div className="tabla-wrapper table-padding pr-4 pl-4">
            {recipe.name && (
                <h4 style={{ margin: "0 0 5px 20px" ,  color:'#359D9E'}} className="text-center mb-3">
                    {`${recipe.name}`}
                </h4>
            )}
            <div className="table-responsive scroll-container-horizontal-recetas">
                <table className="table custom-table table-striped mb-0">
                    <thead 
                        style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "#f8f9fa",
                            zIndex: 1,
                        }}
                    >
                        <tr>
                            <th className="titulo-left-padded" style={{ width: isPacking ? '25%' : '15%' }}>
                                RUBRO
                            </th>
                            {!isPacking && (
                                <th className="titulo-left-padded" style={{ width: '30%' }}>
                                    PRODUCTO
                                </th>
                            )}
                            <th className="titulo-left-padded text-center" style={{ width: '15%' }}>
                                Unidad de medida/kg
                            </th>
                            <th className="titulo-left-padded text-center" style={{ width: '15%' }}>
                                COSTO Q
                            </th>
                            <th className="titulo-left-padded text-center" style={{ width: '15%' }}>
                                COSTO
                            </th>
                            <th className="titulo-left-padded text-center" style={{ width: '10%' }}>
                                ACCIONES
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((system, index) => (
                            <RecetaRow
                                key={index}
                                system={system}
                                index={index}
                                fields={fields}
                                change={change}
                                getCustomers={getCustomers}
                                dollarExchange={dollarExchange}
                                isPacking={isPacking}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
            
            <div className="mt-2">
                <div
                    type="button"
                    className="btn btn-light btn-lg btn-block d-flex justify-content-end"
                    onClick={handleAddField}
                >
                    AGREGAR
                </div>
            </div>
        </div>
    );
};

const CategoriaModal = props => {
    const { open,
        closeModal,
        handleAddCategory,
        initialValues,
        message,
        change,
        allValues,
        dollarExchange,
        reset,
    }
        = props

    const [name, setName] = useState(initialValues.name || '');
    const [is_paking, setIsPaking] = useState(initialValues.is_paking || false);
    const [packings, setPackings] = useState(initialValues.recipe_row || []);
    const [is_mano_de_obra, setIsManual] = useState(initialValues.is_mano_de_obra || false);

    useEffect(() => {
        setName(initialValues.name || '');
        setIsPaking(initialValues.is_paking || false);
        setIsManual(initialValues.is_mano_de_obra || false);
        setPackings(initialValues.packings || []);
        if (initialValues.is_paking) {
            handleRecipeChange(true);
        }
    }, [initialValues]);

    const fetchData = (endpoint, params) => {
        return api.get(endpoint, params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const handleRecipeChange = async (event) => {
        setIsPaking(event);
        if (event) {
            setIsManual(false);
            const data = await fetchData('/packing/get_paking_for_product', { PRODUCT: PRODUCT['LATEX'] });
            setPackings(data);
        } else {
            setPackings([]);
        }
    };

    const handleNameChange = (event) => {
        const value = event.target.value;
        setName(value)
    }

    const handleManualChange = (event) => {
        setIsManual(event);
        if (event) {
            setIsPaking(!event);
        }
    };
    const handleCloseModal = () => {
        closeModal();
        reset(); // Reiniciar el formulario al cerrar el modal
    };

    const handleAddCategoryInternal = (values) => {
        const errors = validate(values);
        if (errors.name) throw new SubmissionError(errors);
        const formData = {
            id: initialValues.id ? initialValues.id : undefined,
            name,
            is_iva_credit: values.is_iva_credit,
            is_paking,
            is_mano_de_obra,
            ModalData: (is_paking) ? allValues.recipePacking : (is_mano_de_obra) ? allValues.manual : allValues.recipe

        };
        handleAddCategory(formData, reset);
    };

    return (
        <Modal
            open={open}
            onClose={closeModal}
            center
            classNames={{
                overlayAnimationIn: 'customEnterOverlayAnimation',
                overlayAnimationOut: 'customLeaveOverlayAnimation',
                modalAnimationIn: 'customEnterModalAnimation',
                modalAnimationOut: 'customLeaveModalAnimation',
                modal: 'customModalSizeLatex',
            }}
        >
            <form onSubmit={props.handleSubmit(handleAddCategoryInternal.bind(this))}>
                <div className="pb-4 titulo-modal d-flex justify-content-center">
                    <div className="col-md-12 p-0 mt-2 text-center">
                        <h4>AGREGAR CATEGORÍA DE COSTO</h4>
                    </div>
                </div>
                <div className="row col-12 p-0">
                    {message && <div className="alerta error_mensaje">{message}</div>}
                </div>
                <div className="position-relative">
                    <div className="row row col-sm-12 form-group np-r pr-4 pl-4">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="name">Nombre</label>
                                <Field
                                    name="name"
                                    type="text"
                                    component={renderField}
                                    placeholder="Nombre"
                                    value={name}
                                    onChange={handleNameChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <span className="finca-entre-rios">¿Es receta de empaque?</span>
                                <Field
                                    name="is_paking"
                                    disabled={initialValues && initialValues.id ? true : false}
                                    component={renderSwitch}
                                    type="checkbox"
                                    onChange={handleRecipeChange}
                                    checked={is_paking}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <span className="finca-entre-rios">¿Es mano de obra?</span>
                                <Field
                                    name="is_mano_de_obra"
                                    disabled={initialValues && initialValues.id ? true : false}
                                    component={renderSwitch}
                                    type="checkbox"
                                    onChange={handleManualChange}
                                    checked={is_mano_de_obra}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <span className="finca-entre-rios">
                                    ¿Genera IVA?
                                </span>
                                <Field
                                    name="is_iva_credit"
                                    component={renderSwitch}
                                    type="text"
                                    className="form-control" />
                            </div>
                        </div>


                    </div>
                    {is_mano_de_obra ?
                        <FieldArray
                            name='generic_row'
                            component={GenericTable}
                            allValues={allValues}
                            change={change}
                            initialValues={initialValues}
                        />
                        :
                        is_paking ? (
                            packings.length > 0 ?
                                packings.map((recipe, index) => (
                                        <FieldArray
                                            key={index}
                                            name={`recipe[${recipe.id}]`}
                                            packingId={`${recipe.id}`}
                                            component={TableCategory}
                                            change={change}
                                            initialValues={initialValues}
                                            allValues={allValues}
                                            dollarExchange={dollarExchange}
                                            isPacking={true}
                                            recipe={recipe}
                                        />
                                ))
                                :
                                <div>
                                    <h4
                                        style={{ margin: "0 0 5px 20px" }}
                                    >
                                        {`No hay empaques para LÁTEX`}
                                    </h4>
                                </div>
                        ) : (
                            <FieldArray
                                name="defaultRecipe"
                                component={TableCategory}
                                change={change}
                                allValues={allValues}
                                dollarExchange={dollarExchange}
                            />
                        )
                    }
                    <div className="buttons-box mt-4 mb-4">
                        <button
                            className="btn btn-outline-dark mr-3 btn-modal"
                            onClick={(e) => {
                                e.preventDefault();
                                handleCloseModal();
                            }}
                        >
                            CANCELAR
                        </button>
                        <button type="submit" className="btn btn-primary btn-modal">
                            CONTINUAR
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

const formName = 'CategoriaModal';
const selector = formValueSelector(formName);

const mapStateToProps = (state) => {

    const defaultRecipe = selector(state, 'defaultRecipe') || [];
    const defaultRecipeAll = selector(state, 'recipe') || [];
    const genercRow = selector(state, 'generic_row') || [];


    return { allValues: { recipe: defaultRecipe, recipePacking: defaultRecipeAll, manual: genercRow } };

};

const ConnectedCategoriaModal = connect(mapStateToProps)(CategoriaModal);

export default reduxForm({
    form: formName,
    validate
})(ConnectedCategoriaModal);
